import { render, staticRenderFns } from "./NewProductModal.vue?vue&type=template&id=2d51c472&scoped=true&"
import script from "./NewProductModal.vue?vue&type=script&lang=js&"
export * from "./NewProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d51c472",
  null
  
)

export default component.exports